import {initStore} from './store';
import Price from "../utils/prices";
import Ticket from "../utils/tickets";

const configStore = () => {
    let initial_studio_tour_rid;
    const start_year = new Date().getFullYear();

    switch (start_year) {
        case 2024:
            initial_studio_tour_rid = 56;
            break;
        case 2025:
            initial_studio_tour_rid = 163;
            break;
        default:
            initial_studio_tour_rid = 163; // Ensuring fallback
            break;
    }

    const actions = {
        UPDATE_DELIVERY: (state, delivery) => {
            const {fares, clientState} = state;
            const qty = clientState.tq.concat(clientState.iq);
            const price = new Price(qty, fares);
            const total = price.total() + delivery;
            return {
                ...state,
                totalPrice: total
            };
        },
        SET_DEFAULT: (state, type) => {
            console.log('SET_DEFAULT');
            const {clientState, defaultQty, defaultPrices, tickets} = state;
            console.log('defaultQty[type].quantity', defaultQty[type].quantity);
            console.log('defaultPrices[type]', defaultPrices[type]);
            const price = new Price(defaultQty[type], defaultPrices[type]);

            let transferAdult = false;
            let setQty = clientState.tq.map(t => {
                const adultDefault = defaultQty[type][0];
                if (t.id === adultDefault['id']) {
                    t.quantity = adultDefault.quantity;
                    transferAdult = true;
                }
                return t;
            });
            const adultTix = _.find(setQty, ['id', 'adult']);
            // if (transferAdult) adultTix.quantity = 0;

            const newCsState = {
                ...clientState,
                tq: setQty
            };
            console.log('TYPE', newCsState);
            console.log('TICKETS', tickets);
            let ticketsTemp = [...tickets];
            ticketsTemp = ticketsTemp.map(t => {
                const defaultSlug = type.includes('deluxe') ? 'deluxe_tour' : 'adult';
                if (t.slug === defaultSlug) t.qty = 1;
                return t;
            });

            return {
                ...state,
                tickets: ticketsTemp,
                clientState: newCsState,
                totalPrice: price.total()
            };
        },
        ADD_TICKET: (state, slug) => {
            console.log('ADD_TICKET', slug);
            const {
                tickets, section, fares, clientState, ticketTypeData, parking, dayLimit, groupPriceMessage
            } = state;
            const parkingTix = tickets.find(o => o.slug === 'parking');
            let ticketsTemp = [...tickets];

            let thisTicket = _.find(ticketsTemp, o => {
                return o.slug === slug
            });
            thisTicket.qty++;
            console.log(ticketsTemp);

            // if (slug.includes('family') || slug === 'adult_package' || slug === 'child_package') {
            //   const ticketGroup = new Ticket(ticketsTemp, slug);
            //   ticketsTemp = ticketGroup.breakOut();
            // }

            let giftPrice = 0, giftSlug = '';
            if (_.includes(slug, 'box') || _.includes(slug, 'wallet')) {
                giftPrice = parseFloat(_.find(ticketsTemp, t => t.slug === slug).price);
                giftSlug = slug;
            }
            if (_.includes(slug, 'box')) {
                if (slug.includes('christmas')) slug = 'winter_box';
                else slug = 'gift_box';
            }
            if (slug.includes('wallet')) slug = 'wallet';

            console.log('slug', slug);
            /* TRANSLATE TICKET TYPES FROM ADULT/CHILD TO SPECIFIC TICKET TYPES */
            if (section === 'gift-tickets') {
                if (slug === 'adult' || slug === 'child') slug = slug + '_gift';
            }

            const combinedArr = [
                ...clientState.tq,
                ...clientState.iq
            ];
            console.log('tickets store combinedArr', combinedArr);
            // const checkTickets = new Ticket(combinedArr);
            // console.log('checkTickets.hasGiftAddon()', checkTickets.hasGiftAddon());
            // const ticketObj = !!(checkTickets.hasGiftAddon() && slug.includes('box')) ? checkTickets : new Ticket(combinedArr, slug, 'add');
            const ticketObj = new Ticket(combinedArr, slug, 'add');
            const ticketState = ticketObj.clientState();
            console.log('ticketState', ticketState);
            const converted = ticketObj.converted; // to family or package
            console.log('converted', converted);
            let convertedMessage = '';
            if (converted) {
                if (converted.name.includes('package')) {
                    const packageGroup = new Ticket(ticketsTemp, slug);
                    packageGroup.combineGuidebooks();
                }
                const newPrice = fares.find(o => o.id === converted.name);
                const oldPrice = new Price(converted.qty, fares);
                const savings = parseFloat(oldPrice.total()) - parseFloat(newPrice.price);
                convertedMessage = converted.name.includes('family') ?
                    'A Family ticket has been added in place of your ' + converted.qty[0].quantity + ' Adult and ' + converted.qty[1].quantity + ' Child tickets saving you <b>£' + savings + '</b>.'
                    :
                    'A Package has been added in place of your Souvenir Guidebook and Digital Guidebook saving you <b>£' + savings.toFixed(2) + '</b>.'
                Ticket.prototype.converted = null;
            }

            // console.log('tickets-store fares', fares);
            // var price = parseFloat(ticketsTemp[i].price);
            // const convertToGroup = (ticketObj.totalPeople() >= groupQty && !isGroup);
            const convertedToGroup = ticketObj.convertedToGroup();

            const price = new Price(ticketState, fares);
            const priceTotal = price.total() + giftPrice;

            const tqObj = ticketState.filter(t => {
                return t.id.includes('adult') || t.id.includes('child') || t.id.includes('family')
            });
            const iqObj = ticketState.filter(t => {
                return !t.id.includes('adult') && !t.id.includes('child') && !t.id.includes('family')
            });

            // sessionStorage.setItem('tq', JSON.stringify(tqObj));
            // sessionStorage.setItem('iq', JSON.stringify(iqObj));

            // const s = section ? section : 'studio-tour';
            let newCsState = {
                ...clientState,
                cat: ticketTypeData[section]['catid'],
                tq: tqObj,
                iq: iqObj
            }
            if (parking && slug === 'parking') {
                const parkingObj = {
                    parkingEvID: parking.eventID,
                    parkingEvDate: parking.time,
                    parkingEvTime: parking.time
                }
                Object.assign(newCsState, parkingObj);
            }

            // console.log('newCsState', newCsState);
            const message = convertedToGroup ? groupPriceMessage : '';
            const postObj = new Ticket(ticketState);
            const newTotalPeople = postObj.totalPeople();
            // console.log('postObj.hasGiftAddon()', postObj.hasGiftAddon());
            return {
                ...state,
                tickets: ticketsTemp,
                clientState: newCsState,
                totalAdults: postObj.adultNumber(),
                totalPeople: newTotalPeople,
                totalTickets: postObj.totalTickets(),
                totalPrice: priceTotal,
                isGroup: newTotalPeople > 9,
                postUpdate: true,
                availPackages: postObj.singleCount(),
                hidePackageAddons: postObj.singleCount() === 0,
                giftAddonSelected: postObj.hasGiftAddon(),
                isPostage: postObj.hasGiftAddon(),
                giftAddon: giftSlug,
                deliveryMethod: postObj.hasGiftAddon() ? 'postage' : 'eTicket',
                parkingMaxed: section === 'studio-tour' && parkingTix.qty === postObj.adultNumber(),
                availMaxed: dayLimit && dayLimit <= newTotalPeople,
                showTicketMessage: !!converted || convertedToGroup,
                ticketMessage: !!converted ? convertedMessage : message
            };
        },
        SUBTRACT_TICKET: (state, slug) => {
            console.log('SUBTRACT_TICKET', slug);
            const {
                tickets,
                section,
                totalTickets,
                totalAdults,
                availPackages,
                fares,
                isGroup,
                clientState,
                ticketTypeData,
                dayLimit
            } = state;

            const simpleSlug = !!(section === 'gift-tickets' && (slug === 'adult' || slug === 'child')) ? slug + '_gift' : slug;
            console.log('simpleSlug', simpleSlug);
            let ticketsTemp = [...tickets];
            // const i = ticketsTemp.findIndex(t => t.slug === slug);
            // ticketsTemp[i].qty--;
            let thisTicket = _.find(ticketsTemp, o => {
                return o.slug === simpleSlug
            });
            thisTicket.qty--;
            console.log('ticketsTemp', ticketsTemp);

            let giftPrice = 0;
            if (_.includes(slug, 'box') || _.includes(slug, 'wallet')) {
                giftPrice = parseFloat(_.find(ticketsTemp, t => t.slug === slug).price);
            }
            if (section === 'gift-tickets') {
                if (slug === 'adult' || slug === 'child') slug = slug + '_gift';
            }

            const combinedArr = [
                ...clientState.tq,
                ...clientState.iq
            ];
            // console.log('combinedArr', combinedArr);
            const ticketObj = new Ticket(combinedArr, slug, 'subtract');
            const ticketState = ticketObj.clientState();

            let under4Tix = _.find(ticketsTemp, ['slug', 'child_0_4']);
            let message = '';
            const removeUnder4 = !!(ticketObj.adultNumber() === 0 && under4Tix.qty > 0);
            if (removeUnder4) {
                under4Tix.qty = 0;
                message = 'Children under 4 must be accompanied by an adult. Please add an adult ticket to add a ticket for a child under 4.';
            }
            if (slug.includes('family')) {
                let adultTix = _.find(ticketsTemp, t => t.slug === 'adult');
                let childTix = _.find(ticketsTemp, t => t.slug === 'child');
                if (slug.includes('1')) {
                    if (adultTix.qty > 0) adultTix.qty--;
                    if (childTix.qty > 2) childTix.qty -= 3;
                } else {
                    if (adultTix.qty > 1) adultTix.qty -= 2;
                    if (childTix.qty > 1) childTix.qty -= 2;
                }
                ticketsTemp = _.union(ticketsTemp, adultTix, childTix);
            }

            const price = new Price(combinedArr, fares);
            const priceTotal = price.total() - giftPrice;

            const tqObj = ticketState.filter(t => {
                return t.id.includes('adult') || t.id.includes('child') || t.id.includes('family')
            });
            const iqObj = ticketState.filter(t => {
                return !t.id.includes('adult') && !t.id.includes('child') && !t.id.includes('family')
            });

            // sessionStorage.setItem('tq', JSON.stringify(tqObj));
            // sessionStorage.setItem('iq', JSON.stringify(iqObj));

            const newCsState = {
                ...clientState,
                cat: ticketTypeData[section]['catid'],
                tq: tqObj,
                iq: iqObj
            }
            const parkingTix = ticketsTemp.find(o => o.slug === 'parking');
            if (slug === 'parking' && parkingTix.qty === 0) {
                const parkingObj = {
                    parkingEvID: null,
                    parkingEvDate: null,
                    parkingEvTime: null
                }
                Object.assign(newCsState, parkingObj);
            }
            // console.log('SUBTRACT_TICKET packageNumber', packageNumber);
            const postObj = new Ticket(ticketState);
            const newTotalPeople = postObj.totalPeople();

            return {
                ...state,
                showAvailabilityMessage: false,
                clientState: newCsState,
                tickets: ticketsTemp,
                totalAdults: postObj.adultNumber(),
                totalPeople: newTotalPeople,
                totalTickets: postObj.totalTickets(),
                totalPrice: priceTotal,
                showGroupMessage: false,
                isGroup: newTotalPeople > 9,
                postUpdate: true,
                availPackages: postObj.singleCount(),
                hidePackageAddons: postObj.singleCount() === 0,
                giftAddonSelected: postObj.hasGiftAddon(),
                deliveryMethod: postObj.hasGiftAddon() ? 'postage' : 'e-ticket',
                parkingMaxed: section === 'studio-tour' && parkingTix.qty === postObj.adultNumber(),
                availMaxed: dayLimit && dayLimit <= newTotalPeople,
                showTicketMessage: removeUnder4,
                ticketMessage: message
            };
        },
        REMOVE_TICKETS: (state, slug) => {
            console.log('REMOVE_TICKETS');
            const {tickets, section, totalTickets, totalPeople, fares, isGroup, clientState, ticketTypeData} = state;
            let tqObj = _.find(clientState.tq, t => t.id === slug);
            if (!tqObj) tqObj = _.find(clientState.iq, t => t.id === slug);
            let numberTickets = tqObj.quantity;
            const groupQty = 10;
            let ticketsTemp = [...tickets];
            const adultI = ticketsTemp.findIndex(t => t.slug === 'adult');
            const childI = ticketsTemp.findIndex(t => t.slug === 'child');
            const packageI = ticketsTemp.findIndex(t => t.slug === 'package');
            const guidebookI = ticketsTemp.findIndex(t => t.slug === 'guidebook');
            const digitalI = ticketsTemp.findIndex(t => t.slug === 'digital_guidebook');
            const winterGiftBox = ticketsTemp.findIndex(t => t.slug === 'winter_box');
            const giftBox = ticketsTemp.findIndex(t => t.slug === 'gift_box');

            const simpleSlug = !!(section === 'gift-tickets' && (slug === 'adult' || slug === 'child')) ? slug + '_gift' : slug;
            const i = ticketsTemp.findIndex(t => t.slug === simpleSlug);

            switch (slug) {
                case 'family_2_2':
                    ticketsTemp[adultI].qty = ticketsTemp[adultI].qty - (2 * numberTickets);
                    ticketsTemp[childI].qty = ticketsTemp[childI].qty - (2 * numberTickets);
                    break;
                case 'family_1_3':
                    ticketsTemp[adultI].qty = ticketsTemp[adultI].qty - numberTickets;
                    ticketsTemp[childI].qty = ticketsTemp[childI].qty - (3 * numberTickets);
                    break;
                case 'adult_package':
                    ticketsTemp[adultI].qty = ticketsTemp[adultI].qty - numberTickets;
                    ticketsTemp[packageI].qty = ticketsTemp[packageI].qty - numberTickets;
                    break;
                case 'child_package':
                    ticketsTemp[childI].qty = ticketsTemp[childI].qty - numberTickets;
                    ticketsTemp[packageI].qty = ticketsTemp[packageI].qty - numberTickets;
                    break;
                case 'group_adult':
                    ticketsTemp[adultI].qty = ticketsTemp[adultI].qty - numberTickets;
                    break;
                case 'group_child':
                    ticketsTemp[childI].qty = ticketsTemp[childI].qty - numberTickets;
                    break;
                default:
                    ticketsTemp[i].qty = 0;
            }

            //TO DO: calculate group tickets removal
            //TO DO: calculate gift box removal

            const combinedArr = [
                ...clientState.tq,
                ...clientState.iq
            ];
            // console.log('combinedArr', combinedArr);
            const ticketObj = new Ticket(combinedArr, slug, 'remove');
            const ticketState = ticketObj.clientState();
            const price = new Price(ticketState, fares);

            let under4Tix = _.find(ticketsTemp, ['slug', 'child_0_4']);
            let message = '';
            const removeUnder4 = !!(ticketObj.adultNumber() === 0 && under4Tix.qty > 0);
            if (removeUnder4) {
                under4Tix.qty = 0;
                message = 'Children under 4 must be accompanied by an adult. Please add an adult ticket to add a ticket for a child under 4.';
            }

            const newCsState = {
                ...clientState,
                cat: ticketTypeData[section]['catid'],
                tq: ticketState.filter(t => {
                    return t.id.includes('adult') || t.id.includes('child') || t.id.includes('family')
                }),
                iq: ticketState.filter(t => {
                    return !t.id.includes('adult') && !t.id.includes('child') && !t.id.includes('family')
                })
            }

            const postObj = new Ticket(ticketState);
            const newTotalPeople = postObj.totalPeople();

            return {
                ...state,
                showAvailabilityMessage: false,
                clientState: newCsState,
                tickets: ticketsTemp,
                totalPeople: newTotalPeople,
                totalTickets: postObj.totalTickets(),
                totalPrice: price.total(),
                showGroupMessage: false,
                isGroup: newTotalPeople > 9,
                postUpdate: true,
                showTicketMessage: removeUnder4,
                ticketMessage: message
            };
        },
        REMOVE_PARKING: (state) => {
            const {tickets, totalPrice} = state;
            const ticketsTemp = [...tickets];
            const parking = _.find(ticketsTemp, t => t.slug === 'parking');
            if (parking.qty > 0) {
                const price = parseFloat(parking.price);
                const deduction = price * parking.qty;
                parking.qty = 0;

                return {
                    ...state,
                    tickets: Object.assign(ticketsTemp, parking),
                    totalPrice: totalPrice - deduction
                };
            }
        },
        SET_MESSAGE: (state) => {
            // console.log('SET_MESSAGE');
            const {
                dayLimit,
                totalPeople,
                availMaxedMessage,
                quantityLimit,
                disableGroupTickets,
                disableGroupTicketsMessage,
                groupMaxMessage
            } = state;
            const messages = [
                {
                    condition: dayLimit && dayLimit <= totalPeople,
                    text: availMaxedMessage
                },
                {
                    condition: !!(quantityLimit === totalPeople && disableGroupTickets),
                    text: disableGroupTicketsMessage
                },
                {
                    condition: quantityLimit === totalPeople && !disableGroupTickets,
                    text: groupMaxMessage
                }
            ];
            let message = '';
            const showMessage = messages.filter(m => {
                return !!m.condition;
            });
            const hasTicketMessage = showMessage.length > 0;
            if (hasTicketMessage) {
                message = _.head(showMessage).text;

                return {
                    ...state,
                    showTicketMessage: hasTicketMessage,
                    ticketMessage: message
                };
            }
        },
        CHANGE_TYPE: (state) => {
            console.log('CHANGE_TYPE');
            const {tickets, clientState} = state;

            const tQty = clientState.tq.map(t => {
                t.quantity = 0;
                return t;
            });
            const iQty = clientState.iq.map(t => {
                t.quantity = 0;
                return t;
            });
            const newCS = {
                ...clientState,
                tq: tQty,
                iq: iQty,
                evdate: null,
                evid: null,
                evtime: null
            };
            // console.log('newCS', newCS);
            const ticketsTemp = tickets.map(t => {
                t.qty = 0;
                return t;
            });
            // console.log('ticketsTemp', ticketsTemp);

            return {
                ...state,
                clientState: newCS,
                tickets: ticketsTemp,
                totalPeople: 0,
                totalTickets: 0,
                totalPrice: 0,
                postUpdate: true,
                timerActive: false,
                eventDates: null,
                selectedDay: null,
                selectedTime: null,
                selectedDate: null,
                selectedDateTime: null,
            };
        },
    };
    initStore(actions, {
        section: 'studio-tour',
        disableGroup: false,
        nextSectionName: null,
        nextSection: null,
        checkoutStep: 1,
        checkoutStepped: 1,
        lastStep: 3,
        initType: true,
        changeType: false,
        deluxeTickets: [],
        parking: null,
        // deluxeTickets: [[
        //   { time: "2020-05-05T10:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-05T12:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-05T15:00:00Z", free: 100, eventID: "90-1063901" }
        // ], [
        //   { time: "2020-05-06T10:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-06T12:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-06T15:00:00Z", free: 100, eventID: "90-1063901" }
        // ], [
        //   { time: "2020-05-07T10:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-07T12:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-07T15:00:00Z", free: 100, eventID: "90-1063901" }
        // ], [
        //   { time: "2020-05-08T10:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-08T12:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-08T15:00:00Z", free: 100, eventID: "90-1063901" }
        // ], [
        //   { time: "2020-05-09T10:00:00Z", free: 100, eventID: "90-1063901" },
        //   { time: "2020-05-09T12:00:00Z", free: 100, eventID: "90-1063901" }
        // ]],
        btsTickets: [],
        // btsTickets: [[
        //   { time: "2020-06-04T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-04T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-05T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-05T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-11T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-11T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-12T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-12T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-18T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-18T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-19T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-19T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-22T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-22T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-23T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-23T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ], [
        //   { time: "2020-06-24T09:30:00Z", free: 100, eventID: "101-1063901" },
        //   { time: "2020-06-24T11:00:00Z", free: 100, eventID: "101-1063901" }
        // ]],
        ticketTypeData: {
            'behind-the-seams': {
                name: 'Behind the Seams',
                rid: 101,
                evid: 50,
                catid: "WBBTS"
            },
            'studio-tour': {
                name: 'Studio Tour',
                rid: initial_studio_tour_rid,
                evid: 20,
                catid: "WBSTD"
            },
            'gift-tickets': {
                name: 'Gift Tickets',
                rid: 0,
                evid: '0-0',
                catid: "WBSTD"
            },
            'deluxe-tour': {
                name: 'Deluxe Tour',
                rid: (location.hostname.includes('wbstudiotour') && !location.hostname.includes('test')) ? 90 : 90, //90?
                evid: 44,
                catid: "WBDLX"
            },
            'parking': {
                name: 'Priority Parking',
                rid: (location.hostname.includes('wbstudiotour') && !location.hostname.includes('test')) ? 125 : 125,
                evid: 71
            }
        },
        ticketTypes: [],
        tickets: [],
        ticketQuantities: [],
        extrasQuantities: [],
        fares: [],
        ticketQty: {
            adult: 1,
            child: 0
        },
        ticketGroups: [],
        groupPrices: {},
        totalTickets: 1,
        totalAdults: 1,
        totalPeople: 1,
        totalPrice: 0,
        availPackages: 1,
        selectedEvent: null,
        postUpdate: false,
        hasParking: false,
        parkingEventID: null,
        giftAddon: null,
        giftAddonName: null,
        giftWinter: false,
        hasAddons: true,
        firstName: null,
        lastName: null,
        email: null,
        address1: null,
        address2: null,
        city: null,
        geostate: null,
        postal: null,
        country: null,
        phone: null,
        affiliate: null,
        deliveryMethods: null,
        deliveryMethod: 'eTicket',
        deliveryPrice: null,
        deliveryAddress1: null,
        deliveryAddress2: null,
        deliveryCity: null,
        deliveryState: null,
        deliveryPostal: null,
        deliveryCountry: null,
        quantityLimit: 23,
        dayLimit: null,
        defaultQty: {
            'studio-tour': [
                {id: "adult", quantity: 1}
            ],
            'gift-tickets': [
                {id: "adult_gift", quantity: 1}
            ],
            'deluxe-tour': [
                {id: "deluxe_tour", quantity: 1}
            ],
            'behind-the-seams': [
                {id: "adult", quantity: 1}
            ]
        },
        defaultPrices: {
            'studio-tour': [
                {id: "adult", price: 0}
            ],
            'gift-tickets': [
                {id: "adult_gift", price: 0}
            ],
            'deluxe-tour': [
                {id: "deluxe_tour", price: 0}
            ],
            'behind-the-seams': [
                {id: "adult", price: 0}
            ]
        },
        clientState: {
            "cat": "WBSTD",
            "lang": "en",
            "tq": [
                {id: "adult", quantity: 1},
                {id: "child", quantity: 0},
                {id: "child_0_4", quantity: 0},
                {id: "group_adult", quantity: 0},
                {id: "group_child", quantity: 0},
                {id: "family", quantity: 0},
                {id: "family_1_3", quantity: 0},
                {id: "family_2_2", quantity: 0},
                {id: "adult_package", quantity: 0},
                {id: "child_package", quantity: 0},
                {id: "adult_gift", quantity: 0},
                {id: "child_gift", quantity: 0},
                {id: "family_1_3_gift", quantity: 0},
                {id: "family_2_2_gift", quantity: 0},
                {id: "adult_gift_box", quantity: 0},
                {id: "child_gift_box", quantity: 0},
                {id: "child_0_4_gift_box", quantity: 0},
                {id: "family_1_3_gift_box", quantity: 0},
                {id: "family_2_2_gift_box", quantity: 0}
            ],
            "iq": [
                {id: "guidebook", quantity: 0},
                {id: "digital_guidebook", quantity: 0},
                {id: "group_guidebook", quantity: 0},
                {id: "parking", quantity: 0},
                {id: "gift_box", quantity: 0},
                {id: "winter_box", quantity: 0},
                {id: "wallet", quantity: 0}
            ],
            "sessionRemaining": 0,
            "reset": false,
            "services": [],
            "servtext": "",
            "servcontact": "",
            "discount": "",
            "status": "",
            "type": "",
            "amount": "",
            "discountID": "",
            "discountData": {"amount": "", "discountCode": "", "discountID": "", "status": "", "type": ""},
            "delivery": {
                "firstName": "",
                "lastName": "",
                "email": "",
                "address1": "",
                "address2": "",
                "city": "",
                "state": "",
                "postal": "",
                "affiliate": ""
            },
            "billing": {
                "firstName": "",
                "lastName": "",
                "email": "",
                "address1": "",
                "address2": "",
                "city": "",
                "state": "",
                "postal": ""
            },
            "evdate": null,
            "evid": null,
            "deliveryMethod": "eTicket"
        }
    });
};

export default configStore;
